import React from 'react';

import {SingleQuestionContent} from 'app/quizzes/components/AttemptQuizPage/SingleQuestionContent';

import type {QuestionProps} from 'app/quizzes/types';

type Props = {
  onClick?: () => void;
} & QuestionProps;

export const EditQuestion = ({question, n, onClick}: Props) => {
  let correctAnswers: Record<string, boolean> = {};
  question.answers.forEach((answer) => {
    correctAnswers[answer.id] = answer.correct;
  });

  return (
    <div onClick={onClick}>
      <SingleQuestionContent
        index={n - 1}
        isEditable={true}
        duration={undefined}
        question={question}
        selectedAnswers={[]}
        correctAnswers={correctAnswers}
      />
    </div>
  );
};
